module.exports = [


    {
        title: "人工智能算法平台",
        id: 'a4',
        introduce: [
            {
                type: "img",
                inner: "/static/img/software/programme2.png",
            },
            {
                type: "subtitle",
                inner: "人工智能研发平台是复杂的AI体系和复杂的业务体系之间的一座桥梁，能够将业务需求通过机器学习、自然语言处理、视觉技术、智能决策技术等人工智能手段融合到业务管理中，同时能够有效保护数据安全、节省人力成本",
            },
            {
                type: "html",
                inner: `
        <p>平台介绍</p>
        <p style='text-indent:2em'>以自然语言的方式，通过语音文本与智能系统进行交互，实现从信息系统到智能助理的巨大跨越 </p>
        <p>平台优势</p>
        <p style='text-indent:2em'>系统能够通过与实验室相关设备的对接，实时获取科研人员的操作记录并上传系统</p>

        <p>行业推广</p>
        <p style='text-indent:2em'>全过程电子记录，减少人力操作</p>
        <p style='text-indent:2em'>数据真实、安全、可靠</p>

        `
            }
        ],
    },

];